import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { media, theme } from '@marketing-site/styles';
import { Stack, Typography } from '@mui/material';
import {
  Job,
  useFetchJobListingsQuery,
} from '@marketing-site/api/careers/apiSlice';
import { ActiveFilter, JobsFilters } from './JobsFilters';
import { JobsByDepartment, JobsTable } from './JobsTable/JobsTable';

type OpenPositionsProps = {
  jobs: Job[];
};

export const OpenPositions = () => {
  const {
    data: jobsData,
    error: jobsError,
    isLoading: jobsLoading,
  } = useFetchJobListingsQuery({
    includeCompensation: true,
  });

  const [jobsToDisplay, setJobsToDisplay] = useState(null);
  const [activeFilter, setActiveFilter] = useState<ActiveFilter>(null);

  useEffect(() => {
    if (activeFilter === null) {
      setJobsToDisplay(jobsData?.jobs);
      return;
    } else {
      const filteredJobs = jobsData?.jobs.filter(
        (job) => job[activeFilter.key] === activeFilter.value
      );
      setJobsToDisplay(filteredJobs);
    }
  }, [activeFilter, jobsData]);

  const handleUpdateFilter = (filter: ActiveFilter) => {
    setActiveFilter(filter);
  };

  return (
    <Stack
      gap={{ mobile: 300, desktop: 600 }}
      maxWidth={1100}
      m={'0 auto'}
      pt={'64px'}
      width={'92%'}
    >
      <Header>Open Positions ({jobsData?.jobs?.length})</Header>
      {jobsData && (
        <JobsFilters
          filters={jobsData?.filters}
          onChange={handleUpdateFilter}
        />
      )}
      {jobsData && <JobsTable jobs={jobsToDisplay} />}
    </Stack>
  );
};

const Container = styled.div`
  max-width: 1100px;
  display: flex;
  flex-direction: column;
  gap: 48px;
  margin: 0 auto;
  padding-top: 64px;
  width: 92%;
`;

const Header = styled.h4`
  font-size: 32px;
  line-height: 40px;
  font-weight: 800;
  margin-bottom: 8px;
  ${media.tablet`
    font-size: 24px;
    line-height: 32px;
    width: 280px;
  `};
`;
